import { z } from 'zod';

/** Rechte je Nutzer – identisch zur bisherigen PHP-Middleware (all_perm_keys). */
/** ankauf_lesen: Ankauf nur ansehen (Read-only), ankauf: bearbeiten – neu gegenüber der PHP-Middleware */
/** erp: ERP-Connector einrichten und Fehler bearbeiten (neu) */
/** produkte_* / bilder_bearbeiten / leitsystem_verwalten: feinere Rechte für den Bereich Produkte (PIM, Briefing Teil G, Abschnitt 9) */
export const RECHTE = [
  'view_dashboard', 'marketplace', 'channels', 'payouts', 'admin', 'users', 'ankauf', 'ankauf_lesen', 'erp',
  'produkte_lesen', 'produkte_bearbeiten', 'produkte_bulk', 'produkte_ki', 'bilder_bearbeiten', 'leitsystem_verwalten',
] as const;
export type Recht = (typeof RECHTE)[number];
export const RechteSchema = z.record(z.enum(RECHTE), z.boolean());
export type Rechte = z.infer<typeof RechteSchema>;

/** dxl_admin = Plattform (DXL), admin/mitarbeiter = Nutzer eines Marktplatzes */
export const ROLLEN = ['dxl_admin', 'admin', 'mitarbeiter'] as const;
export type Rolle = (typeof ROLLEN)[number];

/** erp: ERP-Connector (Business Central ↔ Shopify, docs/erp-connector.md) */
export const MODULE = ['marktplatz', 'ankauf', 'werbung', 'erp'] as const;
export type Modul = (typeof MODULE)[number];

/**
 * Rechte ohne gespeicherten Schlüssel erben vom übergeordneten Recht (PIM G-E12: „Backfill aus marketplace bzw. admin“) –
 * bestehende Nutzer behalten so alles; ein ausdrückliches false schränkt ein.
 */
export const RECHT_ERBT: Partial<Record<Recht, Recht>> = {
  produkte_lesen: 'marketplace',
  produkte_bearbeiten: 'marketplace',
  produkte_bulk: 'marketplace',
  produkte_ki: 'marketplace',
  bilder_bearbeiten: 'marketplace',
  leitsystem_verwalten: 'admin',
};

export function wirksameRechte(r: Partial<Rechte>): Rechte {
  const w = { ...r } as Rechte;
  for (const [kind, eltern] of Object.entries(RECHT_ERBT) as [Recht, Recht][]) {
    if (w[kind] === undefined) w[kind] = !!r[eltern];
  }
  return w;
}

export function standardRechte(rolle: Rolle): Rechte {
  const alle = Object.fromEntries(RECHTE.map((r) => [r, true])) as Rechte;
  if (rolle === 'mitarbeiter') {
    alle.admin = false;
    alle.users = false;
    alle.payouts = false;
    alle.erp = false;
    alle.leitsystem_verwalten = false;
  }
  return alle;
}

/** Zwei-Faktor ist für Administratoren Pflicht – wie bisher. */
export function zweiFaktorPflicht(rolle: Rolle): boolean {
  return rolle === 'dxl_admin' || rolle === 'admin';
}
